import { useOutletContext, Navigate } from 'react-router-dom'

interface User {
  id: string
  email: string
  displayName: string
  role?: 'user' | 'admin'
}

interface AppContext {
  me: User | null
  setMe: (user: User | null) => void
}

interface ProtectedRouteProps {
  children: React.ReactNode
}

export default function ProtectedRoute({ children }: ProtectedRouteProps) {
  const { me } = useOutletContext<AppContext>()
  
  if (!me) {
    return <Navigate to="/login" replace />
  }
  
  return <>{children}</>
}